export const REDUX_NAMESPACE = 'PLAYBACK';
export const WAIT_FOR_BUFFERED_FRAMES_DELAY = 100;
